<template lang="pug">
  .home.padding-container
    p {{ $t("message.hello") }}
</template>

<script>

export default {
  name: "home"
};
</script>

<style lang="scss">

</style>